import { Avatar, Box, Icon, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { useProduct } from "./useProduct";

const renderHeader = function () {
  return (
    <Typography variant="caption" color="secondary" fontSize={14}>
      {this.headerName}
    </Typography>
  );
};

const columns = [
  {
    field: "imageUrl",
    headerName: "IMAGEM",
    renderHeader,
    renderCell: ({ row }) => {
      return (
        <GridActionsCellItem
          icon={<Avatar sx={{ width: 24, height: 24 }} src={row.imageUrl} />}
          label="Detalhes"
        />
      );
    },

    width: 80,
  },
  {
    field: "title",
    headerName: "TÍTULO",
    renderHeader,
    width: 220,
  },
  {
    field: "description",
    headerName: "DESCRIÇÃO",
    renderHeader,
    width: 240,
  },
  {
    field: "date",
    headerName: "DATA DE CADASTRO",
    renderHeader,
    width: 180,
  },
  {
    field: "createdBy",
    headerName: "QUEM CADASTROU",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedAt",
    headerName: "ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedBy",
    headerName: "QUEM FEZ A ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "actions",
    headerName: "AÇÕES",
    type: "actions",
    renderHeader,
    getActions: ({ row }) => [
      <Tooltip title="Ver detalhes">
        <GridActionsCellItem
          icon={<Icon>open_in_new</Icon>}
          label="Detalhes"
          onClick={row.showDetails}
        />
      </Tooltip>,
    ],
    width: 200,
  },
];

export default function ProductsList() {
  const { request, onNextPage } = useProduct();

  const { data, loading, page, limit, currentPage, totalPages, totalItems } =
    request;

  return (
    <Box sx={{ height: 500, flex: 1 }}>
      <DataGrid
        initialState={{
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              updatedAt: false,
              updatedBy: false,
              createdBy: false,
            },
          },
        }}
        disableColumnResize
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        loading={loading}
        paginationMode="server"
        rowHeight={36}
        rows={data}
        isRowSelectable={false}
        columns={columns}
        pageSizeOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        //autoPageSize
        rowCount={totalItems || 0}
        paginationModel={{ page, pageSize: limit }}
        onPaginationModelChange={onNextPage}
        rowsPerPageOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        disableSelectionOnClick
        pagination
      />
    </Box>
  );
}
